import { MapPin, Phone, Crown, X, ChevronRight } from "lucide-react";
import { useCentre } from "@/context/CentreContext";
import Logo from "@/components/Logo";

export default function CentreModal() {
  const { centres, current, selectorOpen, setSelectorOpen, selectCentre } = useCentre();
  if (!selectorOpen) return null;

  return (
    <div className="fixed inset-0 z-[110] flex items-end sm:items-center justify-center bg-black/90 backdrop-blur-md sm:p-4"
      data-testid="centre-modal">
      <div className="relative w-full sm:max-w-4xl bg-hp-dark border-t sm:border border-white/10 max-h-[92vh] sm:max-h-[90vh] flex flex-col rounded-t-2xl sm:rounded-none overflow-hidden">
        <div className="sm:hidden mx-auto mt-2.5 h-1 w-10 rounded-full bg-white/20" aria-hidden />
        {current && (
          <button onClick={() => setSelectorOpen(false)} className="absolute right-4 top-4 text-neutral-400 hover:text-hp-yellow z-10 p-1"
            data-testid="centre-modal-close"><X size={24} /></button>
        )}
        <div className="px-5 pt-5 pb-3 sm:p-10 sm:pb-6 shrink-0">
          <div className="sm:hidden mb-4"><Logo imgClass="h-7" /></div>
          <p className="label-eyebrow">Réseau national Horsepower</p>
          <h2 className="font-display text-2xl sm:text-4xl font-black uppercase tracking-tight mt-1.5 sm:mt-2">
            Choisissez votre centre
          </h2>
          <p className="text-neutral-400 text-sm mt-1.5 sm:mt-2">Contact, horaires et rendez-vous s'adaptent à votre centre.</p>
        </div>

        <div className="overflow-y-auto px-4 pb-6 sm:px-10 sm:pb-10">
          <div className="grid sm:grid-cols-2 gap-2.5 sm:gap-4">
            {centres.map((c) => (
              <button key={c.slug} onClick={() => selectCentre(c.slug)}
                data-testid={`centre-option-${c.slug}`}
                className="hp-card text-left group relative flex items-stretch overflow-hidden active:scale-[0.99] transition-transform">
                <div className="w-24 sm:w-28 shrink-0 overflow-hidden">
                  <img src={c.image} alt="" className="h-full w-full object-cover" loading="lazy" />
                </div>
                <div className="flex-1 min-w-0 p-3.5 sm:p-5">
                  <div className="flex items-center gap-2">
                    <h3 className="font-display text-lg sm:text-xl font-bold uppercase tracking-tight group-hover:text-hp-yellow transition-colors">{c.city}</h3>
                    {c.is_mother && <span className="flex items-center gap-1 bg-hp-yellow text-black text-[9px] font-bold uppercase tracking-wider px-1.5 py-0.5"><Crown size={10} /> Maison mère</span>}
                  </div>
                  <div className="mt-1.5 space-y-1 text-xs sm:text-sm text-neutral-400">
                    {c.postal_city && <p className="flex items-center gap-1.5 truncate"><MapPin size={13} className="text-hp-yellow shrink-0" />{c.postal_city}</p>}
                    <p className="flex items-center gap-1.5"><Phone size={13} className="text-hp-yellow shrink-0" />{c.phone}</p>
                  </div>
                </div>
                <ChevronRight size={18} className="self-center mr-3 text-neutral-600 group-hover:text-hp-yellow shrink-0" />
              </button>
            ))}
          </div>
        </div>
      </div>
    </div>
  );
}
